// ── Follow-up flags + keyboard shortcuts for the Mail page ──────────────────
// Pure (no DOM, no network) so both rules are unit-tested.
//
// OUTLOOK'S FLAG MENU RESOLVES "TOMORROW" IN THE PERSON'S OWN DAY, which is
// why the date is computed here in the browser and sent as YYYY-MM-DD — the
// API never guesses a day in the host's zone (see api/src/mailClient.js
// flagPatch). The choices match Outlook's own: This week is due the Friday of
// this week (today if it is already Friday or the weekend), Next week starts
// the following Monday and is due that Friday.

// The flag rules live in @harvus/shared (shared/src/mailFlags.ts) so the iOS
// Mail screens resolve "This week" to the same Friday. Re-exported here so
// existing web imports are unchanged.
export { FLAG_CHOICES, flagForChoice, flagDueLabel, mailLocalDate as localDate } from '@harvus/shared';

// ── Keyboard shortcuts ───────────────────────────────────────────────────────
// Single keys, the Outlook-on-the-web "Gmail" shortcut set (the one people
// already know from other clients). Never fired while typing in a field.
export const MAIL_SHORTCUTS = [
  { keys: ['n'], action: 'new', label: 'New message' },
  { keys: ['r'], action: 'reply', label: 'Reply' },
  { keys: ['a'], action: 'replyAll', label: 'Reply all' },
  { keys: ['f'], action: 'forward', label: 'Forward' },
  { keys: ['e'], action: 'archive', label: 'Archive' },
  { keys: ['#', 'Delete'], action: 'delete', label: 'Delete' },
  { keys: ['u'], action: 'toggleRead', label: 'Mark read / unread' },
  { keys: ['l'], action: 'flag', label: 'Flag / clear flag' },
  { keys: ['v'], action: 'move', label: 'Move to folder' },
  { keys: ['j', 'ArrowDown'], action: 'next', label: 'Next message' },
  { keys: ['k', 'ArrowUp'], action: 'prev', label: 'Previous message' },
  { keys: ['?'], action: 'help', label: 'Show shortcuts' },
];

/** The action a keydown maps to, or null. `target` is the event target. */
export function mailShortcutFor({ key, ctrlKey, metaKey, altKey, target } = {}) {
  if (ctrlKey || metaKey || altKey) return null;
  const tag = target && target.tagName ? String(target.tagName).toLowerCase() : '';
  if (tag === 'input' || tag === 'textarea' || tag === 'select') return null;
  if (target && (target.isContentEditable || (target.closest && target.closest('[contenteditable="true"]')))) return null;
  const hit = MAIL_SHORTCUTS.find((s) => s.keys.includes(key));
  return hit ? hit.action : null;
}
